import React, { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { IRoute } from '../models/routes.interface';
import FileNotFound from '../pages/404-not-found/file-not-found';
import UnderConstructionPage from '../pages/under-constrcution/under-construction-page';
import Loader from '../common/loader';
interface Props {
  routes: IRoute[];
}

export default function AppModules({ routes }: Props) {
  const MyWorkItems = React.lazy(() => import('../pages/my-work-items'));
  const Exceptions = React.lazy(
    () => import('../pages/my-work-items/exceptions/exceptions')
  );
  const DamagesClaims = React.lazy(
    () => import('../pages/my-work-items/damages-claims')
  );
  const CreateClaim = React.lazy(
    () => import('../pages/my-work-items/damages-claims/create-claim')
  );
  const InvoiceDiscrepancy = React.lazy(
    () =>
      import('../pages/my-work-items/invoice-discrepancy/invoice-discrepancy')
  );
  const TenderTabs = React.lazy(() => import('../pages/my-work-items/tenders'));
  const IntegrationFailure = React.lazy(
    () => import('../pages/my-work-items/intergration-failure')
  );
  const TransportView = React.lazy(
    () => import('../pages/my-work-items/exceptions/screens/transport-view')
  );
  const TenderView = React.lazy(
    () =>
      import('../pages/my-work-items/tenders/tenders-grid/tender-view-by-id')
  );
  const UpdateCheckCalls = React.lazy(
    () => import('../pages/my-work-items/update-check-calls')
  );
  const CheckCallUpdate = React.lazy(
    () => import('../pages/my-work-items/update-check-calls/check-call')
  );
  const MissingRates = React.lazy(
    () => import('../pages/my-work-items/exceptions/screens/missing-rates')
  );
  const MissingRatesDetails = React.lazy(
    () => import('../pages/my-work-items/missing-rate-details')
  );

  const FailedTransaction = React.lazy(
    () =>
      import('../pages/my-work-items/intergration-failure/failed-transaction')
  );
  const AllLoads = React.lazy(
    () => import('../pages/load-management/all-loads')
  );
  const LoadBoard = React.lazy(
    () => import('../pages/load-management/load-board')
  );
  const LoadSummary = React.lazy(
    () => import('../pages/load-management/load-summary/load-summary')
  );
  const LoadDetailsByStatus = React.lazy(
    () => import('../pages/common/load-details-by-status')
  );
  const LoadDetailsByTenderId = React.lazy(
    () => import('../pages/load-management/all-loads/load-details-by-tender-id')
  );
  const QuoteDetailsById = React.lazy(
    () => import('../pages/load-management/load-board/quote-details-by-id')
  );
  const ScoreCard = React.lazy(() => import('../pages/score-card'));
  const Invoices = React.lazy(() => import('../pages/Invoices'));
  const Compliance = React.lazy(() => import('../pages/compliance/compliance'));
  const CreateInsuranceForm = React.lazy(
    () => import('../pages/compliance/insurance/insurance-form')
  );
  const CreateLicensingForm = React.lazy(
    () => import('../pages/compliance/licensing/licensing-form')
  );
  const Contracts = React.lazy(() => import('../pages/contracts/contracts'));
  const ContractInfo = React.lazy(
    () => import('../pages/contracts/contract-information')
  );
  const CreateContract = React.lazy(
    () => import('../pages/contracts/create-contract')
  );
  const CarrierPortalSettings = React.lazy(
    () => import('../pages/carrier-portal-settings')
  );

  const TransitLoadsMap = React.lazy(
    () => import('../pages/load-management/load-summary/transit-loads-map')
  );

  const InvoiceDraftsByInvoiceId = React.lazy(
    () => import('../pages/Invoices/drafts/drafts-invoice-details')
  );

  return (
    <div className="container-fluid">
      <Routes>
        <Route path="/" element={<Navigate to="/myworkitems" />} />
        <Route
          path="/myworkitems"
          element={
            <Suspense fallback={<Loader />}>
              <MyWorkItems />
            </Suspense>
          }
        />
        <Route
          path="/myworkitems/exceptions"
          element={
            <Suspense fallback={<Loader />}>
              <Exceptions />
            </Suspense>
          }
        />
        <Route
          path="/myworkitems/invoicediscrepancy"
          element={
            <Suspense fallback={<Loader />}>
              <InvoiceDiscrepancy />
            </Suspense>
          }
        />
        <Route
          path="/myworkitems/loadboard"
          element={
            <Suspense fallback={<Loader />}>
              <LoadBoard />
            </Suspense>
          }
        />
        <Route
          path="/myworkitems/loadboard/:id"
          element={
            <Suspense fallback={<Loader />}>
              <QuoteDetailsById />
            </Suspense>
          }
        />
        <Route
          path="/tenders/:tenderId"
          element={
            <Suspense fallback={<Loader />}>
              <TenderView />
            </Suspense>
          }
        />
        <Route
          path="/myworkitems/exceptions/transportview"
          element={
            <Suspense fallback={<Loader />}>
              <TransportView />
            </Suspense>
          }
        />
        <Route
          path="/myworkitems/tenders/:status?"
          element={
            <Suspense fallback={<Loader />}>
              <TenderTabs />
            </Suspense>
          }
        />
        <Route
          path="/myworkitems/updatecheckcalls/:transporttype"
          element={
            <Suspense fallback={<Loader />}>
              <UpdateCheckCalls />
            </Suspense>
          }
        />

        <Route
          path="/myworkitems/missingrates"
          element={
            <Suspense fallback={<Loader />}>
              <MissingRates />
            </Suspense>
          }
        />
        <Route
          path="/myworkitems/missingratesdetails"
          element={
            <Suspense fallback={<Loader />}>
              <MissingRatesDetails />
            </Suspense>
          }
        />
        <Route
          path="/myworkitems/integrationfailure"
          element={
            <Suspense fallback={<Loader />}>
              <IntegrationFailure />
            </Suspense>
          }
        />
        <Route
          path="/myworkitems/checkcallupdate/checkcalls"
          element={
            <Suspense fallback={<Loader />}>
              <CheckCallUpdate />
            </Suspense>
          }
        />
        <Route
          path="/myworkitems/integrationfailure/failedtransaction"
          element={
            <Suspense fallback={<Loader />}>
              <FailedTransaction />
            </Suspense>
          }
        />
        <Route
          path="/myworkitems/exceptions/:transportId"
          element={
            <Suspense fallback={<Loader />}>
              <LoadDetailsByTenderId />
            </Suspense>
          }
        />
        <Route
          path="/myworkitems/damagesandclaims"
          element={
            <Suspense fallback={<Loader />}>
              <DamagesClaims />
            </Suspense>
          }
        />
        <Route
          path="/myworkitems/trackingmap"
          element={
            <Suspense fallback={<Loader />}>
              <TransitLoadsMap />
            </Suspense>
          }
        />
        <Route
          path="/myworkitems/damagesandclaims/createclaim"
          element={
            <Suspense fallback={<Loader />}>
              <CreateClaim />
            </Suspense>
          }
        />
        <Route
          path="/loadmanagement/allloads"
          element={
            <Suspense fallback={<Loader />}>
              <AllLoads />
            </Suspense>
          }
        />
        <Route
          path="/loadmanagement/loadboard"
          element={
            <Suspense fallback={<Loader />}>
              <LoadBoard />
            </Suspense>
          }
        />
        <Route
          path="/loadmanagement/loadsummary"
          element={
            <Suspense fallback={<Loader />}>
              <LoadSummary />
            </Suspense>
          }
        />
        <Route
          path="/loadmanagement/loadsummary/:loadtype"
          element={
            <Suspense fallback={<Loader />}>
              <LoadDetailsByStatus />
            </Suspense>
          }
        />
        <Route
          path="/loadmanagement/:loadId"
          element={
            <Suspense fallback={<Loader />}>
              <LoadDetailsByTenderId />
            </Suspense>
          }
        />
        <Route
          path="/loadmanagement/loadboard/:id"
          element={
            <Suspense fallback={<Loader />}>
              <QuoteDetailsById />
            </Suspense>
          }
        />
        <Route
          path="/loadmanagement/loadsummary/intransitloads/map"
          element={
            <Suspense fallback={<Loader />}>
              <TransitLoadsMap />
            </Suspense>
          }
        />
        <Route
          path="/scorecard"
          element={
            <Suspense fallback={<Loader />}>
              <ScoreCard />
            </Suspense>
          }
        />
        <Route
          path="/compliance"
          element={
            <Suspense fallback={<Loader />}>
              <Compliance />
            </Suspense>
          }
        />
        <Route
          path="/compliance/createinsurance"
          element={
            <Suspense fallback={<Loader />}>
              <CreateInsuranceForm />
            </Suspense>
          }
        />
        <Route
          path="/compliance/editinsurance"
          element={
            <Suspense fallback={<Loader />}>
              <CreateInsuranceForm />
            </Suspense>
          }
        />
        <Route
          path="/compliance/createlicense"
          element={
            <Suspense fallback={<Loader />}>
              <CreateLicensingForm />
            </Suspense>
          }
        />
        <Route
          path="/compliance/editlicense"
          element={
            <Suspense fallback={<Loader />}>
              <CreateLicensingForm />
            </Suspense>
          }
        />
        <Route
          path="/contracts"
          element={
            <Suspense fallback={<Loader />}>
              <Contracts />
            </Suspense>
          }
        />
        <Route
          path="/createcontract"
          element={
            <Suspense fallback={<Loader />}>
              <CreateContract />
            </Suspense>
          }
        />
        <Route
          path="/contractinformation/:id"
          element={
            <Suspense fallback={<Loader />}>
              <ContractInfo />
            </Suspense>
          }
        />
        <Route
          path="/invoices"
          element={
            <Suspense fallback={<Loader />}>
              <Invoices />
            </Suspense>
          }
        />
        <Route
          path="/invoices/drafts/:invoiceId"
          element={
            <Suspense fallback={<Loader />}>
              <InvoiceDraftsByInvoiceId />
            </Suspense>
          }
        />
        <Route
          path="/settings"
          element={
            <Suspense fallback={<Loader />}>
              <CarrierPortalSettings />
            </Suspense>
          }
        />
        <Route path="*" element={<FileNotFound />} />
        <Route path="/underconstrcution" element={<UnderConstructionPage />} />
      </Routes>
    </div>
  );
}
